import React from 'react';
import { AiOutlineClose } from "react-icons/ai";

const LeadStageModal = ({ closeStatusModal, updateLeadStage, selectedLead ,updateStageToLost,updateStageToWon}) => {
  // console.log('selectedLead:',selectedLead)
  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-opacity-50 bg-black">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
        <div className="flex justify-between items-center">
          <h3 className="text-xl mb-4 text-center">Update Lead Stage</h3>
          <div
            onClick={closeStatusModal}
            className="cursor-pointer text-gray-600 hover:text-gray-900"
          >
            <AiOutlineClose />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <button
            onClick={() => updateLeadStage(selectedLead.id, "new")}
            className="bg-yellow-500 text-white px-4 py-2 rounded"
          >
            New
          </button>
          <button
            onClick={() => updateLeadStage(selectedLead.id, "discovery")}
            className="bg-teal-500 text-white px-4 py-2 rounded"
          >
            Discovery
          </button>
          <button
            onClick={() => updateLeadStage(selectedLead.id, "proposal")}
            className="bg-sky-500 text-white px-4 py-2 rounded"
          >
            Proposal
          </button>
          <button
            onClick={() => updateLeadStage(selectedLead.id, "negotiation")}
            className="bg-orange-600 text-white px-4 py-2 rounded"
          >
            Negotiation
          </button>
          <button
            onClick={() => updateStageToWon(selectedLead.id)}
            className="bg-green-600 text-white px-4 py-2 rounded"
          >
            Won
          </button>
          <button
            onClick={() => updateStageToLost(selectedLead.id)}
            className="bg-red-600 text-white px-4 py-2 rounded"
          >
            Lost
          </button>
        </div>
      </div>
    </div>
  );
};

export default LeadStageModal;